import React, { useState, useEffect,useRef, useLayoutEffect } from 'react';
import {Main,Axios,Loading,usePaginacion,Paginacion} from '../../../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf,faWindowClose,faFileExcel,faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import DatePicker from "react-datepicker";
import {formatearMontoMoneda} from '../../../Helpers/utilidades-globales'
import BusquedaSinForm from '../../../componentes/BusquedaSinForm';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import Swal from 'sweetalert2';
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import {formatearComparacion,formatoMoneda,hacerfocoEnPrimerInput,seleccionarTextoInput,capitalizarNombre} from '../../../Helpers/utilidades-globales';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../../../Helpers/fechas';
import moment from 'moment';
import ReportesEgresosIntegrados from '../../../reportes/ReportesEgresosIntegrados';
import ImpresionPDF from '../../../componentes/ImpresionPDF';
import { ImprimirDetalleEgreso } from '../../../impresiones/detalle-egreso';
import { enterComoTab } from '../../../Helpers/navegacionTeclado';
import { 
    Button, 
    Card, 
    Checkbox, 
    Input, 
    Option, 
    Select, 
    Spinner, 
    Typography, 
    Tabs, 
    Tab,
    TabPanel,
    TabsHeader, 
    TabsBody,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Switch
} from '@material-tailwind/react';
import { convertirMesAñoAfechaCompleta } from '../../ReporteIngresosIntegrales';
import { Tabla } from '../componentes/Tabla';
import { TablaMobile } from '../componentes/TablaMobile';
import { v4 as uuidv4 } from 'uuid';
import { TrashIcon } from '@heroicons/react/24/outline';


const obtenerBancoDefaultId = (bancos = []) => {
    if (!Array.isArray(bancos) || bancos.length === 0) {
        return null
    }

    const norm = (s) => String(s || '').trim().toLowerCase()
    const santanderMatches = bancos.filter((item) => norm(item?.nombre).includes('santander'))
    // Preferimos el "Santander" base, evitando variantes con sufijos numéricos (p. ej. "Santander 2").
    const sinDigitos = santanderMatches.filter((item) => !/\d/.test(item?.nombre || ''))
    const pool = sinDigitos.length ? sinDigitos : santanderMatches
    const bancoSantander =
        pool.find((item) => norm(item.nombre) === 'santander' || norm(item.nombre) === 'banco santander') ||
        [...pool].sort((a, b) => String(a?.nombre || '').length - String(b?.nombre || '').length)[0]

    return bancoSantander?.id_banco ?? bancos[0]?.id_banco ?? null
}

const abrirSeleccionadorConEnter = (event) => {
    if (event.key !== 'Enter') {
        return
    }

    event.preventDefault()

    if (typeof event.currentTarget?.showPicker === 'function') {
        event.currentTarget.showPicker()
        return
    }

    event.currentTarget.click()
}

const buildMinutaPayload = ({ parametros, formaPagos, tandas, rubros, monedas, cajas, comprEgresos, tiposMovBanco, bancos }) => ({
    ...parametros,
    proveedor: parametros.destino === 'proveedor' ? (parametros.nombre_destino || '--') : '--',
    caja: cajas.find((item) => Number(item.id_caja) === Number(parametros.id_caja))?.nombre ?? '--',
    tanda: tandas.find((item) => Number(item.id_tanda) === Number(parametros.id_tanda))?.nombre ?? '--',
    rubro: rubros.find((item) => Number(item.id_rubro_egreso) === Number(parametros.id_rubro_egreso))?.nombre ?? '--',
    moneda: monedas.find((item) => Number(item.id_tipo_moneda) === Number(parametros.id_tipo_moneda))?.nombre ?? '--',
    comprobante_egreso: comprEgresos.find((item) => Number(item.id_tipo_comp_egr) === Number(parametros.id_tipo_compr))?.nombre ?? '--',
    formaPagos: formaPagos.map((formaPago) => ({
        ...formaPago,
        tipo_movimiento: formaPago.f_pago !== 'efectivo'
            ? (tiposMovBanco.find((item) => Number(item.id_tipo_mov_banco) === Number(formaPago.tipo_movimiento))?.nombre ?? '--')
            : null,
        id_banco: bancos.find((item) => Number(item.id_banco) === Number(formaPago.id_banco))?.nombre ?? '--',
    })),
})

export default function CrearEgreso(){
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [IsFetchingData, setIsFetchingData] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const { esCelular } = useContextoGlobal();
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const [contadorConsulta,setContadorConsulta]=useState(0);   
    const [parametros,setParametros]=useState({id_tanda:null,
                                                id_año_fiscal:10,
                                                mesAño:new Date(),
                                                año:new Date(),
                                                tipo:'cronologico',
                                                criterio:'tanda',
                                                destino:'proveedor',
                                                descripcion: null,
                                                nombre_destino:'',
                                                id_obrero:null,
                                                id_iglesia:null,
                                                id_proveedor:null,                                                
                                                formapago:null,
                                                tipo_formapago: null,
                                                rubro:null,
                                                fondo:null,
                                                moneda:1,
                                                caja:null,
                                                fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                                                fechaHasta:new Date(),
                                                fecha:new Date(),
                                                detalle: '',
                                                descripcionCriterio:'',
                                                total_caja:false,
                                                total_diario:false,
                                                total_mensual:false,
                                                total_año:false,
                                                solo_efectivo : 0,
                                                id_tipo_compr: null,
                                                nro_comprobante: null,
                                                id_tipo_mov_banco: null,
                                                solo_borradores: null,
                                                id_tipo_moneda: 1,
                                                id_rubro_egreso: null,
                                                display_tipo_mov_banco: false,
                                                no_agrupar:false})
    const [formaPagos,setFormaPagos]=useState([]);
    const [openFPago,setOpenFPago] = useState(false);
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [tandas,setTandas] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [monedas,setMonedas] = useState([]);
    const [cajas,setCajas] = useState([]);
    const [fondos,setFondos] = useState([]);
    const [formasPago,setFormasPago] = useState([]);
    const [obreros,setObreros] = useState([]);
    const [bancos,setBancos] = useState([]);
    const [iglesias,setIglesias] = useState([]);
    const [tiposMovBanco,setTiposMovBanco] = useState([]);
    const [comprEgresos,setComprEgresos] = useState([]);
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false);
    const [activeTab, setActiveTab] = useState('datosE');
    const meses = [0,1,2,3,4,5,6,7,8,9,10,11,12];
    const {configuracion,paginar,inicializar} = usePaginacion();
    const history = useHistory();
    const inputBusquedaRef = useRef()
    registerLocale('es', es)


    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
    },[])
    
    useEffect(()=>{
        if(!parametros.destino){
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_iglesia:null,id_proveedor:null})
        }else if(parametros.destino=='pastor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }else if(parametros.destino=='proveedor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_obrero:null})
            hacerfocoEnPrimerInput('destino-n')
        }else{
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }
    },[parametros.destino])

    useEffect(()=>{
        subtitulo.current = crearSubtitulosSegunParametros()
    },[parametros,cargandoRegistros]) // agrego a las dependencias la variable cargandoRegistros para que cree el subtitulo inmediatamente aunque no hayan cambiado los parametros porque podría ejecutar el reporte sin modificar la selección o sea con los valores iniciales

      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/tandas'),
            Axios.get('/api/tablasgenerales/reportes/perfiscales'),
            Axios.get('/api/tablasgenerales/rubrosegresos'),
            Axios.get('/api/reportes/tablas/monedas'),
            Axios.get('/api/tablasgenerales/cajas-egresos/lista'),
            Axios.get('/api/reportes/tablas/fondos'),
            Axios.get('/api/reportes/tablas/formaspago'),
            Axios.get('/api/tablasgenerales/obreros'),
            Axios.get('/api/tablasgenerales/tipo-mov-bancos/lista'),
            Axios.get('/api/tablasgenerales/tipocomprobantesegr'),
            Axios.get(`/api/tablasgenerales/bancos`)])
            const tandasObtenidas = vectorResultados[0].data

            setTandas(tandasObtenidas)
            setPeriodosFiscales(vectorResultados[1].data.reverse())
            setRubros(vectorResultados[2].data)
            setMonedas(vectorResultados[3].data)
            setCajas(vectorResultados[4].data)
            setFondos(vectorResultados[5].data)
            setFormasPago(vectorResultados[6].data)
            setObreros(vectorResultados[7].data)
            setTiposMovBanco(vectorResultados[8].data);
            setComprEgresos(vectorResultados[9].data);
            setBancos(vectorResultados[10].data.recordset);
            setParametros((prev) => ({
                ...prev,
                // La tanda en curso (último mes de carga) viene primera en el listado,
                // igual que el default usado en el resto de la app y en reinicializarCriterios.
                id_tanda: tandasObtenidas[0]?.id_tanda ?? null,
            }))

            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const finalizarReporte = ()=>{
        setReporteEnEjecucion(false)
    }

    const buscarIglesiasPorObrero = async (e)=>{
        const id_obrero = e.target.value;
        setParametros({...parametros, id_obrero, id_iglesia: null});
        try{
            if (!id_obrero) {
                setIglesias([]);
                return;
            }
            const iglesias = await Axios.get('/api/tablasgenerales/iglesiasobrero/'+id_obrero)
            setIglesias(iglesias.data)
        }catch(err){
            console.log('Error al buscar los datos generales')  
        }
    }

    const crearSubtitulosSegunParametros = ()=>{
        let descripcion = '';

        switch(parametros.criterio){
            case 'tanda':
                descripcion = `${descripcion} Tanda: ${tandas.filter(item=>item.id_tanda==parametros.id_tanda).map(item=>item.nombre)}`; break
            case 'añofiscal':
                descripcion = `${descripcion} Año fiscal: ${periodosFiscales.filter(item=>item.id_año_fiscal==parametros.id_año_fiscal).map(item=>item.nombre)}`; break
            case 'mesaño':
//                descripcion = `${descripcion} ${document.getElementById('select-mesaño').options[document.getElementById('select-mesaño').selectedIndex].text}`; break
                descripcion = `${descripcion} Mes y año: ${document.getElementById('select-mesaño').value}`; break
            case 'año':
                descripcion = `${descripcion} Año: ${document.getElementById('select-año').value}`; break
            case 'periodo':
                descripcion = `${descripcion} Período: ${document.getElementById('select-periodo-fdesde').value} -->  ${document.getElementById('select-periodo-fhasta').value}`; break
            case 'fecha':
                descripcion = `${descripcion} Fecha: ${document.getElementById('select-fecha').value}`; break
        }

        if (parametros.tipo=='cronologico'){
            //dos formas de recuperar el texto de un select, usando el vector y filter o usando el id y accediendo al DOM
            descripcion = `${descripcion} Moneda: ${monedas.filter(item=>item.id_tipo_moneda==parametros.moneda).map(item=>item.nombre)}`; 
//            descripcion = `${descripcion} Moneda: ${document.getElementById('select-moneda').options[document.getElementById('select-moneda').selectedIndex].text}`
        
            if (parametros.destino){
                descripcion = `${descripcion} Proveedor: ${parametros.destino=='pastor' ? 'Pr. ' : parametros.destino=='iglesia' ? 'Igl.' : ' '} ${parametros.nombre_destino}`
            }

            if (parametros.caja){
                descripcion = `${descripcion} Caja: ${document.getElementById('select-caja').options[document.getElementById('select-caja').selectedIndex].text}`
            }

            if (parametros.fondo){
                descripcion = `${descripcion} Fondo: ${document.getElementById('select-fondo').options[document.getElementById('select-fondo').selectedIndex].text}`
            }

            if (parametros.rubro){
                descripcion = `${descripcion} Rubro: ${document.getElementById('select-rubro').options[document.getElementById('select-rubro').selectedIndex].text}`
            }

            if (parametros.formapago){
                descripcion = `${descripcion} Forma de pago: ${document.getElementById('select-fpago').options[document.getElementById('select-fpago').selectedIndex].text}`
            }

        }
        return descripcion
    }

    const iniciarGrabarEgreso = () => {
        Swal.fire({
            text: 'Está seguro de guardar e imprimir la minuta?',
            showCancelButton: true,
            confirmButtonText: 'Guardar e imprimir',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                  grabarEgreso();
                } else console.log("Se canceló la creación de un nuevo egreso")
            }
        )
    }

    const validarParametros = ()=>{
        const saldo = calcularSaldoPago(parametros.monto, formaPagos);

        if (!parametros.id_tipo_compr){
            Swal.fire(`Falta seleccionar un tipo de comprobante`,'','info')  
            return
        }

        if (parametros.destino=="proveedor" && !parametros.id_proveedor){
            alert('Falta seleccionar un proveedor')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="pastor" && !parametros.id_obrero){
            alert('Falta seleccionar un ministro')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="iglesia" && !parametros.id_iglesia){
            alert('Falta seleccionar una iglesia')
            inputBusquedaRef.current.focus()
            return
        }

        
        if (!parametros.id_rubro_egreso){
            Swal.fire(`Falta seleccionar una cuenta contable`,'','info')  
            return
        }

        if (!parametros.id_caja){
            Swal.fire(`Falta seleccionar una caja`,'','info')  
            return
        }
        
        if (!parametros.descripcion){
            Swal.fire(`Falta añadir una descripción para continuar`,'','info')  
            return;
        }

        if (parametros.fecha == null){
            Swal.fire(`Falta añadir una fecha para continua`,'','info')  
            return;
        }

        if (parametros.id_tipo_moneda == null){
            Swal.fire(`Falta seleccionar una moneda para continua`,'','info')  
            return
        }

        if (!parametros.monto){
            Swal.fire(`El monto del egreso no puede ser cero`,'','info')  
            return
        }

        if (saldo !== 0) {
            Swal.fire(`Por favor justifique el monto del egreso con la forma de pago`,'','info')  
            if (saldo > 0) {
                Swal.fire(`Falta justificar el monto del egreso con las formas de pago`, '', 'info');
                return;
            } else if (saldo < 0) {
                Swal.fire(`Hay un exceso en las formas de pago respecto al monto del egreso`, '', 'info');
                return;
            }
            return
        }

        iniciarGrabarEgreso()
    }

    const grabarEgreso = async () => { 
        setIsFetchingData(true);
        try { 
            let dataSubmit = {
                cod_op_egr: generarCodigoUnico(),
                fecha: convertirMesAñoAfechaCompleta(parametros.fecha),
                id_tanda: parametros.id_tanda ? Number(parametros.id_tanda) : null,
                id_rubro: parametros.id_rubro_egreso ? Number(parametros.id_rubro_egreso) : null,
                id_obrero: parametros.id_obrero ? Number(parametros.id_obrero) : null,
                id_iglesia: parametros.id_iglesia ? Number(parametros.id_iglesia) : null,
                id_proveedor: parametros.id_proveedor ? Number(parametros.id_proveedor) : null,
                descripcion: parametros.descripcion,
                borrador: parametros.solo_borradores ?? 0,
                id_tipo_comp_egr: parametros.id_tipo_compr && parametros.id_tipo_compr !== '*' ? parametros.id_tipo_compr : null,
                nro_comprobante: parametros.nro_comprobante,
                solo_efectivo: parametros.solo_efectivo,
                monto: parametros.monto,
                id_caja: parametros.id_caja ? Number(parametros.id_caja) : null,
                id_tipo_moneda: parametros.id_tipo_moneda ? Number(parametros.id_tipo_moneda) : null,
                detalle: parametros.detalle,
                formaPagos
            };

            const dataCreacion = await Axios.post('/api/tablasgenerales/egresos/grabar', dataSubmit);
            localStorage.setItem('egresoId', JSON.stringify({ id_egreso: dataCreacion.data[0].id_egreso_resultado }));
            ImprimirDetalleEgreso(
                buildMinutaPayload({
                    parametros,
                    formaPagos,
                    tandas,
                    rubros,
                    monedas,
                    cajas,
                    comprEgresos,
                    tiposMovBanco,
                    bancos,
                }),
                parametros.fecha,
                ""
            )
            setIsFetchingData(false);     
            setTimeout(() => {
                history.push({
                    pathname: '/egreso/detalle',
                });
            }, 2000);      
        } catch (error) {
            console.log('Error al ejecutar el guardado', error);
            setIsFetchingData(false);
            Swal.fire(`No se pudo guardar el nuevo egreso (Temporalmente se muestra el detalle del error para control: ${JSON.stringify(error)})`,'','error')
        }
    }

    const cleanUpData = () => { 
        setDatos([]);
    }

    const cleanUpFormaPago = (code) => { 
        Swal.fire({
            text: '¿Está seguro de eliminar ésta formade pago?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                    const newFormaPagos = formaPagos.filter(item => item.cod_op_egr_pago !== code);
                    setFormaPagos(newFormaPagos);
                } else console.log("Se canceló la eliminación de la forma de pago")
            }
        )
    }

    const handleFPagoOpenDialog = () => { 
        setOpenFPago(true);
    }

    const goToEgresoList = ()=>{
        history.push({
            pathname: '/egresos',
            state: { restoreSearch: true },
        })
    }

    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        <div className={'mr-6 ml-6'}>
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    Crear Egreso
                </Typography>
            </div>
            
            <Tabs value="datosE" className="max-w-full mt-6 bg-white tabs-egresos">
                <TabsHeader
                    className=""
                    indicatorProps={{
                        className: "bg-gradient-to-tr from-blue-600 to-blue-400 shadow-none !text-white",
                    }}
                >
                    <Tab
                        value={"datosE"}
                        onClick={() => setActiveTab('datosE')}
                        className={`font-semibold ${activeTab==='datosE' ? '!text-white' : ''}`}
                    >
                        Datos del Egreso
                    </Tab>
                    <Tab
                        value={"formaP"}
                        onClick={() => setActiveTab('formaP')}
                        className={`font-semibold ${activeTab==='formaP' ? '!text-white' : ''}`}
                    >
                        Forma de Pago
                    </Tab>
                </TabsHeader>
                <TabsBody>

                    <TabPanel value={"datosE"}>
                        {/* Enter avanza al campo siguiente, igual que el tabulador (agiliza la carga) */}
                        <div onKeyDown={enterComoTab}>
                        <Parametros parametros = {parametros}
                            setParametros={setParametros} 
                            tandas={tandas} 
                            periodosFiscales ={periodosFiscales} 
                            buscarIglesiasPorObrero ={buscarIglesiasPorObrero}
                            centrado={contadorConsulta==0 ? true : false}
                            cajas = {cajas}
                            rubros = {rubros}
                            monedas = {monedas}
                            fondos = {fondos}
                            formasPago = {formasPago}
                            obreros = {obreros}
                            tiposMovBanco = {tiposMovBanco}
                            comprEgresos = {comprEgresos}
                            validarParametros={validarParametros}
                            IsFetchingData = {IsFetchingData}
                            inputBusquedaRef={inputBusquedaRef}
                            formaPagos= {formaPagos}
                        />
                        </div>
                    </TabPanel>

                    <TabPanel value={"formaP"}>
                        <FormasPago parametros = {parametros} 
                            formaPagos={formaPagos}
                            setOpenFPago={setOpenFPago}
                            cleanUpFormaPago={cleanUpFormaPago}
                            bancos={bancos}
                            tiposMovBanco={tiposMovBanco}
                            monto={parametros.monto ?? 0}
                        />

                        <FormaPagoModal
                            setFormaPagos={setFormaPagos}
                            formaPagos={formaPagos}
                            handleFPagoOpenDialog={handleFPagoOpenDialog}
                            openFPago={openFPago}
                            setOpenFPago={setOpenFPago}
                            bancos={bancos}
                            tiposMovBanco={tiposMovBanco}
                        />
                        
                    </TabPanel>
                </TabsBody> 
            </Tabs>    
        
            <div className='flex justify-center'>
                <Button variant="gradient" className="mt-4 w-48 flex justify-center mr-2" onClick={validarParametros}>
                    {IsFetchingData ? <Spinner className="h-4 w-4 mr-2" /> : 'Imprimir y Guardar'}  
                </Button>
                <Button className="mt-4 w-48 flex justify-center bg-gray-900" onClick={goToEgresoList}>
                    Regresar 
                </Button>
            </div>
        </div>

        {esCelular && datos.length > 0 && <TablaMobile registrosAmostrar={datos} cleanUpData={cleanUpData} />}

        {!esCelular && datos.length > 0 && <Tabla
            registrosAmostrar={datos}
            cleanUpData={cleanUpData}
        />}
    </Main>
    )
}

function Parametros({parametros,
                    setParametros,
                    cajas,
                    tandas,
                    buscarIglesiasPorObrero,
                    periodosFiscales,
                    centrado,
                    rubros,
                    tiposMovBanco,
                    comprEgresos,
                    monedas,
                    fondos,
                    obreros,
                    formaPagos,
                    IsFetchingData,
                    validarParametros,
                    inputBusquedaRef,
                    setNombreCriterio}){

    const nombreCriterio = useRef('Seleccione la tanda:')
    const r2 = useRef('null')

    const [buscarDestino,setBuscarDestino] = useState(false)
    const { esCelular} = useContextoGlobal();

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        reinicializarCriterios(setParametros,parametros,nuevoCriterio,tandas,periodosFiscales,setNombreCriterio)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'tanda'})
    }

    const handleCheckSoloBorradores = (e)=>{
        console.log(e);
        setParametros({...parametros, solo_borradores : e.target.value === 'on' ? 1 : 0})
    }

    const handleChangeNombre = (e)=>{
        setParametros({...parametros,nombre_destino : e.target.value})
    }

    const finalizarSeleccionObrero = (item)=>{
        setParametros({...parametros,id_obrero : item.id_obrero,nombre_destino:capitalizarNombre(item.nom_simple),id_proveedor:null,id_iglesia:null})
        setBuscarDestino(false)
    }

    const finalizarSeleccionProveedor = (item)=>{
        setParametros({...parametros,id_proveedor : item.id_proveedor,nombre_destino:item.nombre,id_obrero:null,id_iglesia:null})
        setBuscarDestino(false)
    }

    const finalizarSeleccionIglesia = (item)=>{
        setParametros({...parametros,id_iglesia : item.id_iglesia,nombre_destino:item.nombre,id_proveedor:null,id_obrero:null})
        setBuscarDestino(false)
    }
    
    return <Card className="mt-4 w-full px-2 lg:px-5 mb-10 relative shadow-none">
                <div className="flex f-col mt-[-20px]">
                    {/*<Prueba ref2={r2}/>
                    <button onClick ={()=>alert(r2.current.options[r2.current.selectedIndex].text)}>macho</button>*/}
                    
                <Card className="w-full px-6 py-3 mb-3 shadow-md">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        {/* Primera columna */}
                        <div className="flex items-center gap-2 w-full egreso-new">
                            <div className='w-[220px]'>
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    Fecha:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <DatePicker selected={parametros.fecha} 
                                        id="select-fecha"
                                        className="select-bg-ui !h-9"
                                        dateFormat="dd/MM/yyyy"
                                        onChange={date => setParametros({...parametros,fecha:date})} 
                                        locale="es"
                                    />                                        
                                </div>   
                            </div>
                        </div>
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    Tipo Comprobante:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <Seleccionador id='select-caja' vector={comprEgresos} valor={parametros.id_tipo_compr} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_compr:e.target.value})} claves={{id:'id_tipo_comp_egr',nombre:'nombre'}}/>
                                </div>   

                            </div>
                        </div>

                        {/* Segunda columna */}
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    Tanda:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <Seleccionador id="select-tanda" vector={tandas} valor={parametros.id_tanda} nombre="" onchange={(e)=>setParametros({...parametros,id_tanda:e.target.value})} claves={{id:'id_tanda',nombre:'nombre'}}/>
                                </div>   
                            </div>
                        </div>
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    N° Comprobante:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <Input
                                        onChange={(e) => setParametros({ ...parametros, nro_comprobante: e.target.value })} 
                                        name="nombre" 
                                        color='black'
                                        placeholder="N° Comprobante" 
                                        maxLength={200}
                                        className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                        labelProps={{
                                            className: "before:content-none after:content-none",
                                        }}
                                    />
                                </div>   
                            </div>
                        </div>
                    </div>
                </Card>

                <Card className="w-full px-6 py-3 mb-3 shadow-md">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        {/* Primera columna */}
                        <div className="flex items-center gap-2 egreso-new">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1">
                                    Pagado a:
                                </Typography>
                            </div>
                            <div className="select-ui-data mt-3 w-full">
                                <Select
                                    label="Seleccionar Destino"
                                    value={parametros.destino}
                                    className='select-bg-ui w-[95%]'
                                    onChange={(val) => setParametros({...parametros, destino : val})}
                                >
                                    <Option value="proveedor">Proveedor</Option>
                                    <Option value="iglesia">Iglesia</Option>
                                    <Option value="pastor">Pastor</Option>
                                </Select>
                            </div>
                        </div>

                        <div className="flex flex-col">
                            <div className="relative col-span-2 ... mt-3">
                                <Input
                                    name="asunto"
                                    onInput={()=>setBuscarDestino(true)} 
                                    id="destino-n" onClick={()=>seleccionarTextoInput("destino-n")} 
                                    type="text" value={parametros.nombre_destino} 
                                    onChange={handleChangeNombre} ref={inputBusquedaRef} 
                                    placeholder={parametros.destino == 'pastor' ? 'Buscar un ministro' : parametros.destino=='proveedor' ? 'Buscar un proveedor' : 'Buscar una iglesia'}
                                    className="input-ui-data w-full"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                                { parametros.id_pastor && 
                                    <button>
                                        <FontAwesomeIcon className="ic-abm"
                                                        icon={faWindowClose} 
                                                        onClick={()=>console.log('pastor')}/>
                                    </button>}  
                                    {buscarDestino && parametros.destino=='pastor' && parametros.nombre_destino.length > 2 && 
                                        <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                            <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionObrero} origen="obreros"/>
                                        </div>
                                    }
                                    {buscarDestino && parametros.destino=='proveedor' && parametros.nombre_destino.length > 2 && 
                                        <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                            <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionProveedor} origen="proveedores"/>
                                        </div>
                                    }
                                    {buscarDestino && parametros.destino=='iglesia' && parametros.nombre_destino.length > 2 && 
                                        <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                            <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionIglesia} origen="iglesias"/>
                                        </div>
                                    }
                            </div>
                        </div>

                        <div className="flex items-center gap-2 col-span-2">
                            <div className="w-[185px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1">
                                    Descripción:
                                </Typography>
                            </div>
                            <div className='w-full'>
                                <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                <Input
                                    onChange={(e) => setParametros({ ...parametros, descripcion: e.target.value })} 
                                    color='black'
                                    placeholder="Descripción" 
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>

                <Card className="w-full px-6 py-3 mb-3 shadow-md">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                        {/* Primera columna */}
                        <div className="flex items-center gap-2 w-full egreso-new">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    Cuenta Contable:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <Seleccionador id='select-caja' vector={rubros} valor={parametros.id_rubro_egreso} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_rubro_egreso:e.target.value})} claves={{id:'id_rubro_egreso',nombre:'nombre'}}/>
                                </div>   

                            </div>
                        </div>
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    Caja:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <Seleccionador id='select-caja' vector={cajas} valor={parametros.id_caja} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_caja:e.target.value})} claves={{id:'id_caja',nombre:'nombre'}}/>
                                </div>   

                            </div>
                        </div>

                        {/* Segunda columna */}
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1">
                                    Detalle Contable:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                <Input
                                    onChange={(e) => setParametros({ ...parametros, detalle: e.target.value })} 
                                    color='black'
                                    placeholder="detalle" 
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0 lg:mt-4">
                                    Egreso borrador:
                                </Typography>
                            </div>
                            <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-4 w-full">
                                <Switch
                                    ripple={false}
                                    name="checkcaja"
                                    checked={parametros.solo_borradores === 1}
                                    onChange={(e) => setParametros({ ...parametros, solo_borradores: e.target.checked ? 1 : 0 })}
                                />
                            </div>   
                        </div>

                        {/* Tercera columna */}
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1">
                                    Importe:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                <Input
                                    onChange={(e) => setParametros({ ...parametros, monto: e.target.value })}
                                    type="number"
                                    step="0.01"
                                    color='black'
                                    placeholder="Monto"
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                    Moneda:
                                </Typography>
                            </div>
                            <div className="w-full">
                                <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                    <Seleccionador vector={monedas} valor={parametros.id_tipo_moneda} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_moneda:e.target.value})} claves={{id:'id_tipo_moneda',nombre:'nombre'}}/>
                                </div>   
                            </div>
                        </div>
                    </div>
                </Card>


                    <>                        
                        <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-2 mt-4 w-full'} justify-left hidden`}>
                            <div>
                              <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                          Fecha:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                          <DatePicker selected={parametros.fecha} 
                                              id="select-fecha"
                                              className="select-bg-ui !h-9"
                                              onChange={date => setParametros({...parametros,fecha:date})} 
                                              locale="es"
                                          />                                        
                                        </div>   
                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Rubro:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                            <Seleccionador  id='select-rubro' vector={rubros} valor={parametros.rubro} nombre="Todos" onchange={(e)=>setParametros({...parametros,rubro:e.target.value})} claves={{id:'id_rubro',nombre:'nombre'}}/>
                                        </div>   

                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Tipo Comprobante:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                            <Seleccionador id='select-caja' vector={comprEgresos} valor={parametros.id_tipo_compr} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_compr:e.target.value})} claves={{id:'id_tipo_comp_egr',nombre:'nombre'}}/>
                                        </div>   

                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            N° Comprobante:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                            <Input
                                                onChange={(e) => setParametros({ ...parametros, nro_comprobante: e.target.value })} 
                                                name="nombre" 
                                                color='black'
                                                placeholder="N° Comprobante" 
                                                maxLength={200}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3  mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1">
                                            Detalle Contable:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-48 lg:w-[80%]">
                                        <Input
                                            onChange={(e) => setParametros({ ...parametros, detalle: e.target.value })} 
                                            color='black'
                                            placeholder="detalle" 
                                            maxLength={200}
                                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                            labelProps={{
                                                className: "before:content-none after:content-none",
                                            }}
                                        />
                                        </div>
                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Egreso borrador:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                          <Checkbox
                                              label=""
                                              ripple={false}
                                              name="checkcaja" 
                                              checked={parametros.solo_borradores}
                                              onClick={handleCheckSoloBorradores}
                                              className='w-5 h-5 font-semibold'
                                          />
                                        </div>   
                                    </div>
                                </div>
                            </div>

                            <div>
                              <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Tanda:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                          <Seleccionador id="select-tanda" vector={tandas} valor={parametros.id_tanda} nombre="" onchange={(e)=>setParametros({...parametros,id_tanda:e.target.value})} claves={{id:'id_tanda',nombre:'nombre'}}/>
                                        </div>   
                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Caja:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                            <Seleccionador id='select-caja' vector={cajas} valor={parametros.caja} nombre="Todos" onchange={(e)=>setParametros({...parametros,caja:e.target.value})} claves={{id:'id_caja',nombre:'nombre'}}/>
                                        </div>   

                                    </div>
                                </div>

                                <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4 gap-4'} justify-left`}>
                                    <div>
                                        <Typography variant="h5" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Moneda:
                                        </Typography>
                                    </div>
                                    <div className="col-span-2 ...">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full lg:w-[80%]">
                                          <Seleccionador vector={monedas} valor={parametros.id_tipo_moneda} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_moneda:e.target.value})} claves={{id:'id_tipo_moneda',nombre:'nombre'}}/>
                                        </div>   
                                    </div>
                                </div>
                                  <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3  mt-4 gap-4'} justify-left`}>
                                      <div>
                                          <Typography variant="h5" color="blue-gray" className="mt-1">
                                              Monto:
                                          </Typography>
                                      </div>
                                      <div className="col-span-2 ...">
                                          <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-48 lg:w-[80%]">
                                            <Input
                                                onChange={(e) => setParametros({ ...parametros, monto: e.target.value })} 
                                                type="number" 
                                                color='black'
                                                placeholder="Monto" 
                                                maxLength={200}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                          </div>
                                      </div>
                                  </div>

                                  <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3  mt-4 gap-4'} justify-left`}>
                                      <div>
                                          <Typography variant="h5" color="blue-gray" className="mt-1">
                                              Descripción:
                                          </Typography>
                                      </div>
                                      <div className="col-span-2 ...">
                                          <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-48 lg:w-[80%]">
                                            <Input
                                                onChange={(e) => setParametros({ ...parametros, descripcion: e.target.value })} 
                                                color='black'
                                                placeholder="Descripción" 
                                                maxLength={200}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                          </div>
                                      </div>
                                  </div>
                            </div>
                        </div>
                    </>
            </div>
        </Card>
}

function FormasPago({
    formaPagos,
    setOpenFPago,
    tiposMovBanco,
    cleanUpFormaPago,
    bancos,
    monto
}){
    
const TABLE_HEAD = ["Forma de Pago", "Banco", "Fecha Acreditación", "Monto Bruto", "Valor Cambio Pesos", "Neto Pesos"];

return (
        <Card className="mt-0 w-full p-10 mb-10 relative shadow-none">
            <div className="flex f-col mt-4">
                <div className="flex mt-4 justify-between">
                    <div className='flex gap-1'>
                        <p className='flex font-semibold text-[14px] bg-[#eee]/50 rounded-md mx-2 items-center justify-center my-2 w-[150px]'>
                            Saldo de Pago
                        </p>
                        <span className={`flex justify-right rounded-md items-center font-semibold bg-[#eee]/90 my-2 mx-2 min-w-[60px] px-3
                            ${calcularSaldoPago(monto, formaPagos) === 0 ? 'text-blue-600' : 'text-red-600'}`}>
                            {formatearMontoMoneda(calcularSaldoPago(monto, formaPagos))}
                        </span> 
                    </div>

                    <Button 
                        variant="gradient" 
                        className="mt-2 w-48 flex justify-center" 
                        onClick={() => {
                            if (!monto) 
                                Swal.fire(`Ingrese el monto del egreso antes de añadir formas de pago`,'','info')  
                            else setOpenFPago(true) 
                        }}
                    >
                        {'Añadir'}  
                    </Button>
                </div>

                <table className="w-full min-w-max table-auto text-left mt-4">
                    <thead>
                    <tr>
                        {TABLE_HEAD.map((head) => (
                        <th
                            key={head}
                            className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70 text-center"
                            >
                            {head}
                            </Typography>
                        </th>
                        ))}

                        <th
                            className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70 text-center"
                            >
                            {'Acciones'}
                            </Typography>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {formaPagos.map((data, index) => {
                        const isLast = index === formaPagos.length - 1;
                        const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";
            
                        return (
                        <tr key={index}>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.f_pago === 'efectivo' ? 'Efectivo' : 'Movimiento Bancario'}
                                    {data.f_pago !== 'efectivo' ? ` - ${tiposMovBanco.find(tipo => Number(tipo.id_tipo_mov_banco) === Number(data.tipo_movimiento))?.nombre}` : ''}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                  {bancos.find(banco => Number(banco.id_banco) === Number(data?.id_banco))?.nombre ?? '--'} 
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.f_acreditacion ? moment(data.f_acreditacion).format('DD/MM/YYYY') : '--'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.m_bruto ? formatearMontoMoneda(Number(data.m_bruto)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.v_cambio_pesos ? formatearMontoMoneda(Number(data.v_cambio_pesos)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.m_neto ? formatearMontoMoneda(Number(data.m_neto)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={`${classes} flex justify-center`}>
                                <TrashIcon className="h-5 w-5 text-gray-900 cursor-pointer" onClick={() => cleanUpFormaPago(data.cod_op_egr_pago)} />
                            </td>
                        </tr>
                        );
                    })}

                    {formaPagos.length === 0 && (
                        <tr>
                            <td colSpan={TABLE_HEAD.length + 1} className="text-center p-4">
                                <Typography variant="small" color="blue-gray" className="font-normal">
                                    No hay datos disponibles
                                </Typography>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </Card>
    )
}

function Seleccionador({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    classancho
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select value={valor} name={name? name : ''} className='h-9' onChange ={onchange} onKeyDown={abrirSeleccionadorConEnter} id={id? id : null}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]}>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { valor!="*" && limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
}   

const reinicializarCriterios = (setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)=>{


    setParametros({...parametros,
                      criterio : nuevoCriterio,
                      id_tanda:tandas[0].id_tanda,
                      id_año_fiscal:periodosFiscales[0].id_año_fiscal,
                      fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                      fechaHasta:new Date(),
                      fecha:new Date(),
                      mesAño:new Date(),
                      año:new Date(),
                    })
}

const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{

    switch(nuevoCriterio){
        case 'tanda' : nombreCriterio.current = 'Seleccione la tanda:';return
        case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
        case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
        case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
        case 'año' : nombreCriterio.current = 'Seleccione el año:';return
        case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
    }
}

const FormaPagoModal = ({
    setFormaPagos, 
    formaPagos,
    openFPago, 
    setOpenFPago, 
    handleFPagoOpenDialog,
    bancos,
    tiposMovBanco
}) => { 

    const bancoDefaultId = obtenerBancoDefaultId(bancos)

    const [currentFPago, setCurrentFPago] = useState({
        f_pago: 'efectivo',
        v_cambio_pesos: 1,
        id_banco: bancoDefaultId
    })

    useEffect(() => {
        if (!openFPago || !bancoDefaultId || currentFPago.id_banco) {
            return
        }

        setCurrentFPago((prev) => ({
            ...prev,
            id_banco: bancoDefaultId,
        }))
    }, [openFPago, bancoDefaultId, currentFPago.id_banco])

    const handleCheckFPago = (type, value) => {
        setCurrentFPago({ ...currentFPago, [type]: value })
    }

    const handleAddFPago = () => {
        if (validateFormaPago([currentFPago])) {
            let fpago = { ...currentFPago, cod_op_egr_pago: generarCodigoUnico() };
            if (currentFPago.f_pago === 'mbancario') fpago.cod_op_lib_banco = generarCodigoUnico();

            setFormaPagos([...formaPagos, { ...fpago }]);
            handleCancelFpago();
        } else {
            Swal.fire({
                icon: 'error',
                title: `<p>Por favor, complete todos los campos al agregar una forma de pago</p>`,
                showCancelButton: true,
            });
        }
    }

    const handleCancelFpago = () => {
        setCurrentFPago({
            f_pago: 'efectivo',
            v_cambio_pesos: 1,
            id_banco: bancoDefaultId
        });
        setOpenFPago(false);
    }

    return (
        <>
            <Dialog open={openFPago} handler={handleFPagoOpenDialog} size="lg" className="max-h-[92vh] overflow-hidden">
                <DialogHeader>Añadir Forma de Pago</DialogHeader>
                <DialogBody className="max-h-[72vh] overflow-y-auto px-5 py-4 xl:px-8 xl:py-6" onKeyDown={enterComoTab}>
                    <div className="flex flex-col">
                        <div className="flex flex-col gap-3">
                            <div className="w-full flex flex-col">
                                <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                    Monto Bruto
                                </Typography>
                                <Input
                                    onChange={(e) => { 
                                        setCurrentFPago({ 
                                            ...currentFPago, 
                                            m_bruto: e.target.value,
                                            m_neto: (e.target.value / (currentFPago.v_cambio_pesos || 1)).toFixed(2)
                                        }) 
                                    }} 
                                    onBlur={() => {
                                        setCurrentFPago(fp => ({
                                            ...fp,
                                            m_bruto: fp.m_bruto !== undefined && fp.m_bruto !== '' 
                                                ? Number(fp.m_bruto).toFixed(2) 
                                                : fp.m_bruto
                                        }))
                                    }}
                                    name="Monto Bruto" 
                                    type='number'
                                    color='black'
                                    placeholder="Monto Bruto" 
                                    value={currentFPago.m_bruto}
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                            </div>
                            <div className="w-full flex flex-col">
                                <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                    Valor de Cambio
                                </Typography>
                                <Input
                                    onChange={(e) => { 
                                        setCurrentFPago({ 
                                            ...currentFPago, 
                                            v_cambio_pesos: e.target.value,
                                            m_neto: (currentFPago.m_bruto / (e.target.value || 1)).toFixed(2)
                                        }) 
                                    }} 
                                    onBlur={() => {
                                        setCurrentFPago(fp => ({
                                            ...fp,
                                            v_cambio_pesos: fp.v_cambio_pesos !== undefined && fp.v_cambio_pesos !== '' 
                                                ? Number(fp.v_cambio_pesos).toFixed(2) 
                                                : fp.v_cambio_pesos
                                        }))
                                    }}
                                    name="nombre" 
                                    type='number'
                                    color='black'
                                    value={currentFPago.v_cambio_pesos}
                                    placeholder="Valor de Cambio Pesos" 
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-3 mt-4 md:flex-row">
                            <div className="w-full flex flex-col">
                                <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                    Monto Neto
                                </Typography>
                                <Input
                                    onChange={(e) => setCurrentFPago({ ...currentFPago, m_neto: e.target.value })} 
                                    name="Monto Neto" 
                                    type='number'
                                    color='black'
                                    value={currentFPago.m_neto}
                                    placeholder="Monto Neto" 
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-2 justify-left mt-4">
                            <Typography variant="h5" color="blue-gray" className="mt-2">
                                Tipo de Pago
                            </Typography>
                            <div className="col-span-2 flex space-x-2 w-full mt-1">
                                <Checkbox
                                    label="Efectivo"
                                    ripple={false}
                                    checked={currentFPago.f_pago == 'efectivo'}
                                    onClick={() => handleCheckFPago('f_pago', 'efectivo')}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleCheckFPago('f_pago', 'efectivo'); } }}
                                    className='w-5 h-5'
                                />
                                <Checkbox
                                    label="Movimiento Bancario (che, dep)"
                                    ripple={false}
                                    checked={currentFPago.f_pago == 'mbancario'}
                                    onClick={() => handleCheckFPago('f_pago', 'mbancario')}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleCheckFPago('f_pago', 'mbancario'); } }}
                                    className='w-5 h-5'
                                />
                            </div>
                        </div>
                        
                        {currentFPago.f_pago === 'mbancario' && (
                            <div className='flex flex-col'>
                                <Typography variant="h6" color="blue-gray" className="mt-2">
                                    Libro Banco
                                </Typography>
                                <div className="flex flex-col gap-3 md:flex-row">
                                    <div className="w-full flex flex-col md:w-1/2">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Tipo Movimiento
                                        </Typography>
                                        <Seleccionador id='select-banco' vector={tiposMovBanco} valor={currentFPago.tipo_movimiento} nombre="Todos" onchange={(e)=>setCurrentFPago({...currentFPago,tipo_movimiento:e.target.value})} claves={{id:'id_tipo_mov_banco',nombre:'nombre'}}/>
                                    </div>
                                    <div className="w-full flex flex-col md:w-1/2">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Nro Comprobante
                                        </Typography>
                                        <Input
                                            onChange={(e) => setCurrentFPago({ ...currentFPago, n_comprobante: e.target.value })} 
                                            name="nombre" 
                                            color='black'
                                            placeholder="Nro Comprobante" 
                                            maxLength={200}
                                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                            labelProps={{
                                                className: "before:content-none after:content-none",
                                            }}
                                        />
                                    </div>
                                </div>  

                                <div className="flex flex-col gap-3 mt-4 md:flex-row">
                                    <div className="flex flex-col w-full md:w-1/2">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Fecha de Emisión
                                        </Typography>
                                        <DatePicker selected={currentFPago.f_emision} 
                                            id="select-fecha"
                                            className="select-bg-ui !h-9"
                                            dateFormat="dd/MM/yyyy"
                                            onChange={date => setCurrentFPago({...currentFPago,f_emision:date})} 
                                            locale="es"
                                        /> 
                                    </div>

                                    <div className="flex flex-col w-full md:w-1/2">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Fecha de Acreditación
                                        </Typography>
                                        <DatePicker selected={currentFPago.f_acreditacion} 
                                            id="select-fecha"
                                            className="select-bg-ui !h-9"
                                            dateFormat="dd/MM/yyyy"
                                            onChange={date => setCurrentFPago({...currentFPago,f_acreditacion:date})} 
                                            locale="es"
                                        /> 
                                    </div>
                                </div>

                                <div className="flex flex-col mt-4">
                                    <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                        Banco
                                    </Typography>
                                    <Seleccionador id='select-banco' vector={bancos} valor={currentFPago.id_banco} nombre="Todos" onchange={(e)=>setCurrentFPago({...currentFPago,id_banco:e.target.value})} claves={{id:'id_banco',nombre:'nombre'}}/>
                                </div>
                            </div>
                        )}
                    </div>
                </DialogBody>
                <DialogFooter className="space-x-2">
                    <Button 
                        variant="gradient" 
                        color="blue" 
                        onClick={handleAddFPago}
                    >
                        Agregar
                    </Button>

                    <Button variant="text" color="blue-gray" onClick={handleCancelFpago}>
                        Cancelar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
}

const validateFormaPago = (formaPagos) => { 
    let isValid = true;
    formaPagos.forEach((fpago) => {
        if (!fpago.f_pago || !fpago.m_bruto || !fpago.v_cambio_pesos || !fpago.m_neto || (fpago.f_pago === 'mbancario' && (!fpago.tipo_movimiento || !fpago.id_banco))) {
            isValid = false;
        }
    });
    return isValid;
}

function generarCodigoUnico() {
    const now = new Date();
    const codigo = 
        now.getFullYear() + // Año
        String(now.getMonth() + 1).padStart(2, '0') + // Mes (con 0 inicial si es necesario)
        String(now.getDate()).padStart(2, '0') + // Día (con 0 inicial si es necesario)
        String(now.getHours()).padStart(2, '0') + // Hora (con 0 inicial si es necesario)
        String(now.getMinutes()).padStart(2, '0') + // Minutos (con 0 inicial si es necesario)
        String(now.getSeconds()).padStart(2, '0') + // Segundos (con 0 inicial si es necesario)
        String(Math.floor(Math.random() * 1000)).padStart(3, '0'); // Número aleatorio de 3 dígitos

    return codigo;
}

function calcularSaldoPago(montoEgreso, formaPagos) {
    const totalPagos = formaPagos.reduce((total, pago) => {
        return total + (parseFloat(pago.m_neto) || 0);
    }, 0);

    const saldo = montoEgreso - totalPagos;

    return saldo;
}
